import { QUESTION } from "../../../actions/learning_provider/question/question_bank_action";

export const initState = {
  list: [],
  is_done: false,
  loading: false,
  errors: [],
  identifieds:[]
};

const questionBankReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case QUESTION.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload
      };
    case QUESTION.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        list: []
      };
    case QUESTION.UPLOAD_QUESTION_BANK:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done: true,
        list: []
      };

    case QUESTION.GET_QUESTION_BANK:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done: false,
        list: payload
      };

      case QUESTION.GET_IDENTIFED:
        return {
          ...state,
          loading: false,
          errors: [],
          is_done: false,
          identifieds: payload
        };

    case QUESTION.ADD_RANDOM_QUESTION:
    case QUESTION.ADD_AUTOMATIC_QUESTION:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done: true,
        list: []
      };
    default:
      return state;
  }
};

export default questionBankReducer;
